module.exports = __webpack_public_path__ + "img/card.d0fc86c3.jpg";